<script>
	import { computePosition, flip, shift, offset, size, autoUpdate } from '@floating-ui/dom'
  import { cn } from '@lib/utils'
	
	let { 
		open = $bindable(false),
		trigger,
		contents,
		placement = "bottom-center",
		offset: offsetValue = 6,
		triggerClass,
		contentClass
	} = $props()

	let triggerRef = $state()
	let contentRef = $state()
	let cleanup = $state()
	let maxHeight = $state(200)

	$effect(async () => {
		if (triggerRef && contentRef) {
			cleanup = autoUpdate(triggerRef, contentRef, setPosition)
		} else {
			cleanup?.()
		}
	})

	async function setPosition() {
		if (!triggerRef || !contentRef) return
		const { x, y } = await computePosition(triggerRef, contentRef, {
			placement,
			middleware: [offset(offsetValue), flip(), shift(), size({
			  apply({ rects, elements, availableHeight }) {
			    Object.assign(elements.floating.style, {
			      minWidth: `${rects.reference.width}px`,
			    });
					maxHeight = availableHeight - (offsetValue * 2)
			  },
			})]
		})
    if (!contentRef) return
		Object.assign(contentRef.style, {
			left: `${x}px`,
			top: `${y}px`,
      zIndex: 10,
		});
	}

</script>

<div class={cn("inline-block w-full", triggerClass)} bind:this={triggerRef}>
  {@render trigger?.()}
</div>

{#if open}
  <div class={cn("w-max-content absolute top-0 left-0", contentClass)} bind:this={contentRef}>
    {@render contents?.({ maxHeight })}
  </div>
{/if}